import React, { useEffect, useRef } from 'react';

/**
 * Markup HTML component
 * Displays raw HTML content on the web page.
 * @param {Object} props
 * @param {string} props.html
 */
export const MarkupHtml = ({ html }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (!html) {
      return;
    }

    const slotHtml = document.createRange().createContextualFragment(html);
    ref.current.innerHTML = '';
    ref.current.appendChild(slotHtml);
  }, [html]);

  return <div ref={ref} />;
};

export default MarkupHtml;
